import { TDeserialisedIntroducerFormData } from 'components/Registration/registration.types';

export const buildAddressLabel = (values: (string | undefined)[]) => {
  const addressString = values
    .map((l) => l && l.trim())
    .filter((l) => l)
    .join(', ');

  return addressString;
};

export const generateUKAddress = (
  values: Omit<TDeserialisedIntroducerFormData, 'registeredTradingAddress'>,
) => {
  return buildAddressLabel([
    values.addressLine1,
    values.addressLine2,
    values.town,
  ]);
};
